import React from 'react';
import { TextInputProps } from './textfield';
import { Form, Input } from 'antd';
import { Rule } from 'antd/lib/form';

export function PhoneInput(props: Omit<TextInputProps, 'maxLength'>) {
  const handleChange = (value: string) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    // This was happily made by ChatGPT! :)
    const regex = /^[0-9\s]*$/;
    const { keyCode, ctrlKey, metaKey } = event;

    if ((ctrlKey || metaKey) && (keyCode === 65 || keyCode === 90 || keyCode === 89)) {
      return true; // allow Ctrl+A, Ctrl+Z, and Ctrl+Y to select all, undo, and redo the text
    }

    const isAllowed = regex.test(String.fromCharCode(keyCode)) || [8, 9, 13, 27, 32, 37, 38, 39, 40].includes(keyCode);
    if (!isAllowed) {
      event.preventDefault();
    }
    return isAllowed;
  };

  const rules: Rule[] = [
    { pattern: /^[0-9\s]+$/g, message: `${props.label} allow only numbers and spaces` },
    { required: props.required, message: `${props.label} is required` },
  ];

  return (
    <>
      <Form.Item name={props.name} label={props.label} rules={rules}>
        <Input
          onKeyDown={handleKeyDown}
          value={props.value}
          maxLength={20}
          onChange={(event) => {
            handleChange(event.target.value);
          }}
          onPressEnter={(event) => {
            handleChange(event.currentTarget.value);
          }}
          disabled={props.disabled}
          placeholder={props.placeholder}
        />
      </Form.Item>
    </>
  );
}
